export default function (value) {
	if (typeof value != 'undefined' && value != null) {
		return Math.floor(value / 12) + ' év';
	} else {
		return '';
	}
}
